import { TenantFeaturesModel, TenantModel } from "../../entities";
import { BaseDataRepository } from "../BaseDataRepository";

export class TenantRepo extends BaseDataRepository<TenantModel> {
  protected baseUrl = 'tenant';

  async getFeaturesAsync(id: number): Promise<TenantFeaturesModel | null> {
    const response = await this.client.get(`${this.baseUrl}/${id}/features`);

    if (!response.success) return null;
    return this.handleResponse<TenantFeaturesModel>(response);
  }

  async saveFeaturesAsync(id: number, features: TenantFeaturesModel): Promise<TenantFeaturesModel | null> {
    const response = await this.client.post(`${this.baseUrl}/${id}/features`, features);
    return this.handleResponse<TenantFeaturesModel>(response);
  }
}

export default TenantRepo;
